module.exports = "/_next/static/images/strategic-planning-training-service-2-c95b328921562ba684dd4facf37fc9d6.webp";